import { createFormHook } from "@tanstack/react-form";
import { fieldContext, formContext } from "./util";
import { TextField } from "./fields/text-field";
import { FormErrors } from "./components/form-errors";
import { SubmitButton } from "./components/submit-button";
import { InputField } from "./fields/input-field";

export const { useAppForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    TextField,
    InputField,
  },
  formComponents: {
    FormErrors,
    SubmitButton,
  },
});
